import { ModuleTypes, EntitiesStatusEnum } from 'components/Modals/Filter/types';
import { config } from 'config/config';
import { RequestMethod } from "utils/useApiClient";

const ownerFilter = [
    {
        name: 'filterBy',
        label: 'general.organization_type',
        type: ModuleTypes.asyncRadio,
        endpoint: config.api.routes.enums.organizationTypes,
        translation: 'general.organization_type',
        isEnum: true,
        required: true,
    },
];

const customerFilter = [
    {
        name: 'customer',
        label: 'general.customer',
        type: ModuleTypes.asyncSelect,
        endpoint: config.api.routes.customers,
        filters: {
            status: [EntitiesStatusEnum.Active],
            limit: 5,
            select: ['name', 'id'],
        },
        valueKey: 'id',
        labelKey: 'name',
        method: 'POST' as RequestMethod,
        required: true,
    },
];

const organizationFilter = [
    {
        name: 'organization',
        label: 'general.reseller',
        type: ModuleTypes.asyncSelect,
        endpoint: config.api.routes.organizations,
        filters: {
            status: [EntitiesStatusEnum.Active],
            limit: 5,
            select: ['name', 'id'],
        },
        valueKey: 'id',
        labelKey: 'name',
        method: 'POST' as RequestMethod,
        required: true,
    },
];

const dateFilter = [
    {
        name: 'date',
        label: 'emailing.mail_date_range',
        type: ModuleTypes.dateRange,
    },
    {
        name: 'category',
        label: 'emailing.scenarios.e_mail_category',
        type: ModuleTypes.asyncSelect,
        endpoint: config.api.routes.mail.categories,
        translation: 'email_templates.categories',
        isEnum: true,
        cacheTime: (24 * 60 * 60 * 1000)
    },
];

const customerMailFilter = [
    {
        name: 'templateId',
        label: 'emailing.scenarios.email_template',
        type: ModuleTypes.asyncSelect,
        endpoint: config.api.routes.mail.template.customer,
        labelKey: 'template_translations',
        valueKey: 'id',
        localeTranslation: true,
    },
];

const organizationMailFilter = [
    {
        name: 'templateId',
        label: 'emailing.scenarios.email_template',
        type: ModuleTypes.asyncSelect,
        endpoint: config.api.routes.mail.template.organization,
        labelKey: 'template_translations',
        valueKey: 'id',
        localeTranslation: true,
    },
];

const templateFilters = [
    {
        name: 'type',
        label: 'emailing.notification_types',
        type: ModuleTypes.asyncCheckbox,
        endpoint: config.api.routes.enums.mailType,
        translation: 'emailing.notification_types',
        isEnum: true,
    },
    {
        name: 'status',
        label: 'emailing.status',
        type: ModuleTypes.asyncCheckbox,
        endpoint: config.api.routes.enums.mailStatus,
        translation: 'email_history.status',
        isEnum: true,
    },
];

export { ownerFilter, customerMailFilter, organizationMailFilter, dateFilter, customerFilter, organizationFilter, templateFilters };
